
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class aiWatchingVideo extends Vue {
  @Prop() formItemData!: any; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  trialOne() {
    this.$emit("trial", "aiWatchingVideo");
  }

  get useFaceShow() {
    return this.formItemData.faceShowDetection.use === 1;
  }

  get faceShowDesc() {
    const descs = [
      "绝对严格检测标准：要求候选人在面试过程中，超过100%以上的时间全脸在屏幕范围内，大约59%的候选人能达成该标准",
      "严格检测标准：要求候选人在面试过程中，超过95%以上的时间全脸在屏幕范围内，大约86%的候选人能达成该标准",
      "正常检测标准：要求候选人在面试过程中，超过90%以上的时间全脸在屏幕范围内，大约92%的候选人能达成该标准",
      "宽松检测标准：要求候选人在面试过程中，超过85%以上的时间全脸在屏幕范围内，大约95%的候选人能达成该标准"
    ];
    return descs[
      this.formItemData.faceShowDetection.configData.successVersion ?? 0
    ];
  }

  rules = {};

  formatTooltip(value: number) {
    const tooltip = ["绝对严格", "严格", "正常", "宽松"];
    return tooltip[value] || value;
  }

  // 校验数据：
  //    (1) 校验不通过，返回 false
  //    (2) 校验通过，返回 true
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
